<template>
  <v-row>
    <v-col xs="12" sm="12" md="12" lg="12">
      <v-card outlined>
        <v-card-title>Export der Rechnungen eines Monats</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="month"
                :items="months"
                item-text="name"
                item-value="value"
                label="Monat"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="year"
                :items="years"
                label="Jahr"
                clearable
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="exportInvoices()">Export</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import apiService from "@/common/api.service";
import { saveAs } from "file-saver/dist/FileSaver";

export default {
  name: "Invoices",
  components: {},
  data() {
    return {
      month: "",
      year: ""
    };
  },
  computed: {
    months() {
      return [
        { name: "Januar", value: 1 },
        { name: "Februar", value: 2 },
        { name: "März", value: 3 },
        { name: "April", value: 4 },
        { name: "Mai", value: 5 },
        { name: "Juni", value: 6 },
        { name: "Juli", value: 7 },
        { name: "August", value: 8 },
        { name: "September", value: 9 },
        { name: "Oktober", value: 10 },
        { name: "November", value: 11 },
        { name: "Dezember", value: 12 }
      ];
    },
    years() {
      let years = [];
      for (let i = 2021; i <= new Date().getFullYear(); i++) {
        years.push(i);
      }
      return years;
    }
  },

  methods: {
    exportInvoices() {
      apiService
        .query("invoices/export/" + this.year + "/" + this.month, {
          responseType: "arraybuffer"
        })
        .then(response => {
          saveAs(
            new Blob([response.data], { type: "application/zip" }),
            "RE-SM-" + this.year + "-" + this.month + ".zip"
          );
        });
    }
  }
};
</script>

<style scoped></style>
